import React from "react";
import ChrisLogo from '../chrislogo.jpg';
import InfiniteScroll from 'react-infinite-scroll-component';
import Comments from './Comments';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
// @ts-ignore
import ShakaPlayerComponent from "./ShakaPlayerComponent";
import ProfilePic from '../ProfilePicTemp.png';
import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle } from '@headlessui/react';
import MoonLoader from 'react-spinners/MoonLoader';
import Cards from 'react-credit-cards-2';
import "react-credit-cards-2/dist/es/styles-compiled.css";
// import clerk from '../utils/clerk';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { getToken, forceLogout } from '../hooks/AuthProvider';
import FeedComponent from './FeedComponent';

// import {
//     formatCreditCardNumber,
//     formatCVC,
//     formatExpirationDate,
//     formatFormData,
//     isCardExpiryValid,
//     isCardCVCValid,
//     isCardNumberValid,
// } from '../utils/cardUtils';

type state = {
    loading: boolean;
    loadingMore: boolean;
    items: any[];
    pageNum: number;
    hasMore: boolean;
    myName: string;
    purchaseShow: boolean;
    purchaseData: post | null;
    purchaseID: string;
    number: string;
    expiry: string;
    name: string;
    cardFocused: string;
    ccv: string;
    isPaymentActive: boolean;
    commentModal: boolean;
    activePostID: string | null;
    commentData: any;
    comments: any[];
    authorizingPurchase: boolean;
    authorizationToken: string | null;
    purchasePollInterval: NodeJS.Timeout | null;
    purchasePollAttempts: number;
    // followingUser: boolean;
}

type props = {};

type post = {
    access: boolean;
    createdAt: string;
    description: string;
    followers: number;
    isPostLiked: boolean;
    likes: number;
    postID: string;
    price: number;
    profilePic: {
        profilePic: string;
        _id: string;
    };
    status: string;
    title: string;
    username: string;
}

export default class Feed extends React.PureComponent<props, state> {
    player: any = React.createRef();
    private payBTN = React.createRef<HTMLButtonElement>();
    private closeModalBTN = React.createRef<HTMLButtonElement>();
    private commentInput = React.createRef<HTMLInputElement>();

    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            loadingMore: false,
            items: [],
            pageNum: 0,
            hasMore: true,
            myName: '',
            purchaseShow: false,
            purchaseData: null,
            purchaseID: '',
            number: '4243 1111 1111 1111',
            expiry: '01/26',
            name: 'DemoName',
            cardFocused: '',
            ccv: '211',
            isPaymentActive: false,
            commentModal: false,
            activePostID: null,
            commentData: null,
            comments: [],
            authorizingPurchase: false,
            authorizationToken: null,
            purchasePollInterval: null,
            purchasePollAttempts: 0,
            // followingUser: false
        }
        this.fetchMoreData = this.fetchMoreData.bind(this);
        this.checkPurchaseStatus = this.checkPurchaseStatus.bind(this);
        this.startPurchasePolling = this.startPurchasePolling.bind(this);
        this.stopPurchasePolling = this.stopPurchasePolling.bind(this);
        this.refetchFeed = this.refetchFeed.bind(this);
    }

    async componentDidMount() {
        const script = document.createElement('script');
        script.src = '/jsencrypt.min.js';
        script.async = true;
        document.body.appendChild(script);

        // Check for purchaseID query parameter
        const urlParams = new URLSearchParams(window.location.search);
        const purchaseID = urlParams.get('purchaseID');
        
        if (purchaseID) {
            this.setState({ 
                authorizingPurchase: true, 
                purchaseID: purchaseID,
                purchasePollAttempts: 0
            });
            this.startPurchasePolling(purchaseID);
        }

        axios.get(`${process.env.REACT_APP_API_URL}api/v1/feed`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            // console.log(res.data);
            this.setState({
                items: res.data.posts,
                loading: false,
                pageNum: 1,
                myName: res.data.self.displayName,
                authorizationToken: res.data.authorizationToken || null,
            });
        }).catch((err: any) => {
            console.error(err.response.data.msg);
            if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token' || err.response.data.msg === 'Invalid token' || err.response.data.msg === 'Token has been invalidated') {
                forceLogout();
            }
        });
    }

    componentWillUnmount() {
        // Clean up polling interval
        if (this.state.purchasePollInterval) {
            clearInterval(this.state.purchasePollInterval);
        }
    }

    startPurchasePolling(purchaseID: string) {
        const interval = setInterval(() => {
            this.checkPurchaseStatus(purchaseID);
        }, 2500); // Poll every 2.5 seconds
        
        this.setState({ purchasePollInterval: interval });
        // Also check immediately
        this.checkPurchaseStatus(purchaseID);
    }

    stopPurchasePolling() {
        if (this.state.purchasePollInterval) {
            clearInterval(this.state.purchasePollInterval);
            this.setState({ purchasePollInterval: null });
        }
    }

    async checkPurchaseStatus(purchaseID: string) {
        const maxAttempts = 15; // 15 attempts * 2.5 seconds = ~37.5 seconds max
        
        if (this.state.purchasePollAttempts >= maxAttempts) {
            this.stopPurchasePolling();
            this.setState({ 
                authorizingPurchase: false,
                purchaseID: ''
            });
            toast.error('Purchase authorization timed out. Please refresh the page.', {
                style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }
            });
            // Clean up URL
            const url = new URL(window.location.href);
            url.searchParams.delete('purchaseID');
            window.history.replaceState({}, '', url.toString());
            return;
        }

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/v1/stripe/purchaseStatus/${purchaseID}`,
                { headers: { 'x-auth-token': getToken() } }
            );

            if (res.data.confirmed === true) {
                // Purchase confirmed! Reload page to show updated feed
                this.stopPurchasePolling();
                
                // Clean up URL before reload
                const url = new URL(window.location.href);
                url.searchParams.delete('purchaseID');
                url.searchParams.set('purchased', 'true'); // Add purchased flag for feed refresh
                
                // Reload page to ensure fresh state and show purchased content
                window.location.href = url.toString();
            } else if (res.data.processing === true) {
                // Payment succeeded but webhook still processing - show processing message
                // Continue polling but don't increment attempts (we're waiting for webhook)
                console.log('Purchase payment succeeded, waiting for webhook processing...');
            } else {
                // Not confirmed yet, continue polling
                this.setState({ purchasePollAttempts: this.state.purchasePollAttempts + 1 });
            }
        } catch (err: any) {
            console.error('Error checking purchase status:', err);
            // On error, stop polling and show error
            this.stopPurchasePolling();
            this.setState({ 
                authorizingPurchase: false,
                purchaseID: ''
            });
            toast.error('Error checking purchase status. Please refresh the page.', {
                style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }
            });
            // Clean up URL
            const url = new URL(window.location.href);
            url.searchParams.delete('purchaseID');
            window.history.replaceState({}, '', url.toString());
        }
    }

    async refetchFeed() {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}api/v1/feed`,
                { headers: { 'x-auth-token': getToken() } }
            );
            this.setState({
                items: res.data.posts,
                pageNum: 1,
                myName: res.data.self.displayName,
                authorizationToken: res.data.authorizationToken || null,
            });
        } catch (err: any) {
            console.error('Error refetching feed:', err);
        }
    }

    fetchMoreData() {
        if (!this.state.hasMore || this.state.loadingMore) return;

        const nextPage = this.state.pageNum + 1;
        this.setState({ loadingMore: true });

        axios.get(`${process.env.REACT_APP_API_URL}api/v1/feed?page=${nextPage}`, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            if (res.data.posts.length !== 0) {
                this.setState(prevState => ({
                    items: [...prevState.items, ...res.data.posts],
                    pageNum: nextPage,
                    loadingMore: false,
                    authorizationToken: res.data.authorizationToken || prevState.authorizationToken,
                }));
            } else {
                this.setState({ hasMore: false, loadingMore: false });
            }
        }).catch(err => {
            this.setState({ loadingMore: false });
            if (err.response?.data?.msg === 'No posts found') {
                this.setState({ hasMore: false });
            } else if (err.response?.data?.msg === 'Not Verified' || err.response?.data?.error === 'Missing Auth Token') {
                forceLogout();
            }
        })
    }

    toggleLike(e: any, postID: any) {
        axios.put(`${process.env.REACT_APP_API_URL}api/v1/post/${postID}/like`, null, { headers: { 'x-auth-token': getToken() } }).then((res) => {
            // Update selected `post` in state to avoid updating all posts ...
            // this.setState({})
            var updatedItems = this.state.items.map((post) => {
                if (post.postID === postID) {
                    post.likes = res.data.likes;
                    post.isPostLiked = !post.isPostLiked;
                }
                return post;
            });
            this.setState({ items: updatedItems });
        }).catch((err) => {
            console.error(err);
            if (err.response.data.msg === 'Not Verified' || err.response.data.error === 'Missing Auth Token') {
                forceLogout();
            } else {
                // e.target.classList.toggle('text-red-500');
                // e.target.classList.toggle('fa-heart');
                // Toast like error to user
                toast.error('An error has occurred!', { style: {
                    color: '#ffffff',
                    backgroundColor: '#242C37',
                }});
            }
        });
    }

    render() {
        return <div className="col-span-2 px-4">
            <Toaster position="bottom-center" />
            
            {/* Authorization Modal */}
            <Transition show={this.state.authorizingPurchase}>
                <Dialog className="relative z-50" onClose={() => {}}>
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                    </TransitionChild>
                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <TransitionChild
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel className="mx-auto max-w-sm rounded-lg bg-gray-800 p-6 text-white">
                                <DialogTitle className="text-lg font-semibold mb-4 text-center">
                                    Authorizing content...
                                </DialogTitle>
                                <div className="flex flex-col items-center justify-center py-4">
                                    <MoonLoader color="#ffffff" size={40} />
                                    <p className="mt-4 text-sm text-gray-300 text-center">
                                        Please wait while we confirm your purchase.
                                    </p>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </Dialog>
            </Transition>

            {(() => {
                if (this.state.loading === false && this.state.items === undefined) {
                    // Display different message if user isnt following a creator ...
                    return <div className="bg-gray-700 w-full my-3 px-4 py-4 rounded-md">
                        <h1 className="text-lg font-bold text-center">No posts available! Check back later when a creator makes a post!</h1>
                    </div>
                } else if (this.state.loading === false && this.state.items.length !== 0) {
                   return <FeedComponent items={this.state.items} onLoadMore={this.fetchMoreData} hasMore={this.state.hasMore} authorizationToken={this.state.authorizationToken || undefined} />
                } else if (this.state.loading === false && this.state.items.length === 0) {
                    return <div className="bg-gray-700 w-full my-3 px-4 py-4 rounded-md">
                        <h1 className="text-lg font-bold text-center">No posts available! Check back later when a creator makes a post!</h1>
                    </div>
                } else {
                    return <div>
                    <div className="bg-gray-700 w-full my-3 rounded-md">
                        <div className="flex animate-pulse items-center h-full px-6 py-4">
                            <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                            <div className="ml-4 w-full">
                                <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                                <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                            </div>
                        </div>
                        <div className="animate-pulse px-4 py-4">
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                        </div>
                    </div>
                    <div className="bg-gray-700 w-full my-4 rounded-md">
                        <div className="flex animate-pulse items-center h-full px-6 py-4">
                            <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                            <div className="ml-4 w-full">
                                <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                                <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                            </div>
                        </div>
                        <div className="animate-pulse px-4 py-4">
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                        </div>
                    </div>
                    <div className="bg-gray-700 w-full my-4 rounded-md">
                        <div className="flex animate-pulse items-center h-full px-6 py-4">
                            <span className="min-h-10 min-w-10 rounded-full bg-slate-700"></span>
                            <div className="ml-4 w-full">
                                <div className="h-2 w-1/4 bg-slate-700 rounded"></div>
                                <div className="h-2 w-1/12 mt-2 bg-slate-700 rounded"></div>
                            </div>
                        </div>
                        <div className="animate-pulse px-4 py-4">
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                            <div className="h-2 mt-2 w-full bg-slate-700 rounded"></div>
                        </div>
                    </div>
                </div>
                }
            })()}
        </div>
    }
}